"use client";

import dynamic from "next/dynamic";
import LeadFormSkeleton from "./LeadFormSkeleton";

const LeadForm = dynamic(() => import("./LeadForm"), {
  ssr: false,
  loading: () => <LeadFormSkeleton />,
});

export default LeadForm;
